export enum PermissionIntero {
  // Rotas com permissionIntero = 0 (acesso livre)
  ALTERAR_EMPRESA_REDE = 0,
  LGPD_PAGE = 281,
  HOME = 0,
  RELATORIOS = 0,
  CONFIGURACOES_ECOMMERCE = 0,
  CADASTRO_COMISSOES = 0,
  GRUPO_METAS = 0,
  LANCAMENTO_METAS = 0,
  DISTRIBUICAO = 0,
  BATIMENTO_TRANSFERENCIAS = 0,
  INCLUIR_TRANSFERENCIAS = 0,
  ENTRADA_NOTAS_ANTIGO = 0,
  PERCENTUAL_DIA = 0,
  PERCENTUAL_COMISSAO = 0,
  CONFIGURACOES = 0,
  CONFIGURACOES_EDITAR = 0,
  CONFIGURACOES_INTEGRACOES = 0,
  CADASTRO_GERAL = 0,
  DIVERGENCIAS = 0,

  // Containers (pais sem permissão própria)
  ATRIBUTOS = 0,
  PLATAFORMAS = 0,

  // Principal
  MINHA_EMPRESA = 204,
  LIVE_DESKTOP = 0,

  // Administrativo
  CLIENTES = 5,
  CLASSIFICACAO_CLIENTES = 180,
  CONFIGURACOES_LOJAS = 61,
  REDES = 284,
  FUNCIONARIOS = 134,
  LOJAS = 9,
  TABELA_PRECOS = 17,
  TIPOS_MENSAGENS = 258,
  TABELAS_TRIBUTACAO = 115,
  ALIQUOTAS_INTERESTADUAIS = 285,
  USUARIOS = 71,
  PERFIL_USUARIOS = 159,
  PROFISSOES = 260,
  MOTIVO_TROCA = 286,
  CONTADORES = 287,
  REPRESENTANTES = 144,
  TERMINAIS = 235,
  AUTORIZACAO_GERENCIAL = 236,
  TIPOS_DE_CODIGO = 313,
  TRANSPORTADORAS = 145,

  // Atacado
  IMPORTACAO_XML = 289,
  PEDIDO_FORNECEDORES = 290,
  PEDIDOS_VENDA = 146,
  TIPOS_CLIENTES = 291,

  // Estoque
  CONFERENCIA_NOTA = 303,
  INVENTARIOS = 12,
  EMBALAGENS = 304,
  ETIQUETAS = 305,
  ATRIBUTOS_PAI = 293,
  ATRIBUTOS_FILHO = 292,
  COLECOES = 301,
  COMPRADORES = 294,
  CORES = 295,
  GRADES = 296,
  GRUPOS = 297,
  LINHAS = 298,
  MATERIAIS = 299,
  MODELOS = 300,
  TAMANHOS = 18,
  UNIDADES = 302,
  ENTRADA_NOTAS = 26,
  FORNECEDORES = 10,
  PEDIDO_COMPRAS = 31,
  PRODUTOS = 15,
  HISTORICO_PRODUTOS = 306,
  TRANSFERENCIAS = 32,
  ENTRADA_SAIDA_AVULSA = 312,
  CONFERENCIA = 165,
  COTAS = 153,
  RELATORIO_ESTOQUE = 283,

  // Financeiro
  ACOMPANHAMENTO_METAS = 307,
  BANCOS = 308,
  CARTOES = 36,
  CENTRO_CUSTOS = 43,
  CONTA_CORRENTE = 45,
  CONDICOES_PAGAMENTO = 7,
  EMPRESTIMOS = 262,
  MOEDAS = 263,
  CAMBIO = 0,
  TIPOS_DESCONTO = 309,
  GRUPOS_FINANCEIROS = 47,
  CLASSIFICACOES_FINANCEIRAS = 44,
  GRUPOS_CONTAS = 46,
  PAGAMENTOS = 48,
  RECEBIMENTOS = 267,
  CONCILIACAO_BANCARIA = 268,
  RECEBIMENTO_CAIXA = 269,
  DEMONSTRATIVOS_FINANCEIROS = 270,
  CONCILIACAO_CARTOES = 271,
  RELATORIO_FINANCEIRO = 282,

  // Fiscal
  CERTIFICADOS_DIGITAIS = 272,
  CFOP = 125,
  CONFIGURACOES_AUTOMATIZADAS = 129,
  NOTAS_FISCAIS = 139,
  GESTOR_NOTAS = 141,
  NCM = 128,
  NUMERO_SERIE = 132,
  TIPO_NOTAS = 126,
  TRIBUTO_CLASSIFICACAO = 288,
  ALIQUOTAS_IVA = 259,
  EXPORTACAO_FISCAL = 314,
  GESTOR_VALES = 315,

  // Integrações
  ALTERDATA_PAY = 273,
  BIMER = 274,
  BLUVE = 275,
  LOGS_INTEGRACOES = 276,
  NAPP_SOLUTIONS = 277,
  NF_STOCK = 278,
  WEBHOOK = 279,
  ECOMMERCE = 254,

  // Varejo
  CONSULTA_PRECO = 310,
  CONSULTA_VENDAS = 16,
  GESTOR_PEDIDOS = 205,
  NETSHOPPER = 98,
  PDVUP = 208,
  PRE_VENDA = 168,
  LANCAMENTO_CAIXA = 311,
  AUTOATENDIMENTO = 999,

  // Auditoria
  LOG_LGPD = 281,

  // Permissão especificas
  GERAR_PAGAMENTO_PARA_NOTA = 114,
}
